import Transformer from '@/transformers/transformer'

export default class unitMeasurementTransformer extends Transformer {
  static fetch (unit) {
    return {
      id: unit.id,
      abbr: unit.abbr,
      name: unit.name,
      isActive: unit.is_active
    }
  }
}
